export function hasOnConfirm(obj: any): obj is { onConfirm: () => void } {
  return (
    typeof obj === 'object' && !!obj && 'onConfirm' in obj && typeof obj.onConfirm === 'function'
  )
}
